const es_ES = {
    homepage_title: 'Descargar CalendarTask móvil con código QR',
    homepage_slogn: 'CalendarTask versión móvil',
    homepage_ios_download: 'App Store en revisión...',
    homepage_download: 'Descargar',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Descargar CalendarTask móvil con código QR',
    phonedownload_slogan: 'Sincroniza con PC y tablet, anota en cualquier lugar',
    phonedownload_send_vip: 'Instala la app y recibe membresía VIP',
    phonedownload_screenshot: 'Captura de pantalla',
    phodedownload_macos: 'CalendarTask versión macOS',
    phodedownload_windows: 'CalendarTask versión Windows',
    phodedownload_otherbutton: 'Ver ahora',
    phodedownload_about: 'Contacto',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Sin anuncios',
    feature_easy: 'Vista mensual, simple y fácil',
    feature_reminder: 'Recordatorio personalizado',
    feature_countdown: 'Cuenta regresiva aniversario',

    vip_task_succ: 'Éxito. Descarga la app móvil para activar VIP',
    vip_task_error: 'Recepción fallida',

    group_slogn: 'Invitación CalendarTask equipo',

    tt_title: 'CalendarTask',
    tt_share_1: 'Compartido contigo',
    tt_share_2: 'Horario',
    tt_share_show_1: 'Escanea el código QR con la app "CalendarTask", PC y móvil mostrarán',
    tt_share_show_2: 'el horario',
    tt_share_scan_1: 'Escanear con',
    tt_share_scan_2: 'app "CalendarTask"',
    tt_share_succ: 'Sincronización exitosa',

    v2_copyright: 'Contacto service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Todos los derechos reservados.',
    v2_download_appstore: 'Descargar en App Store',
    v2_download_googleplay: 'Disponible en Google Play',

    v2_main_title: 'CalendarTask Móvil',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Móvil',
    v2_main_description: 'Busca <span class="name">CalendarTask</span> en App Store o Google Play',
    v2_download_ios: 'Descargar iOS',
    v2_download_android: 'Descargar Android',
    v2_download_harmonyos: 'Descargar HarmonyOS',
    v2_sync_status: '¡Sincronización completada! 1 subido, 0 descargados',
    v2_feature_title: 'Sincronización multi-dispositivo',
    v2_feature_description: 'Sincroniza entre móvil, tablet y PC'
};
export default es_ES;
